<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Bank List</div>
        <div>
          <bread-crumb :bread-crumbs="['Partner Summary', 'Bank List']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-data-table fixed-header  height="55vh" :headers="dessertHeaders" :items="desserts" item-key="name">
        <template v-slot:[`item.actions`]="{ item }">
          <v-switch hide-details height="0px" color="primary"> </v-switch>
          <v-icon small color="primary" @click="deleteItem(item)"> </v-icon>
        </template>
        <template v-slot:item.Bankname="{ item }">
          <a
            class="text-decoration-underline"
            @click="editPage()"
            :title="item.Editbank"
          >
            {{ item.Bankname }}
          </a>
        </template>
        <template v-slot:item.Branch="{ item }">
          <a
            class="text-decoration-underline"
            @click="Bankbranch()"
            :title="item.Bankbranch"
          >
            {{ item.Branch }}
          </a>
        </template>
        <!-- 
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small color="primary" class="mr-2" @click="editItem(item.id)">
            mdi-content-save-edit-outline-box-multiple
          </v-icon>
          <v-icon small color="primary" @click="deleteItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </template> -->

        <template v-slot:top>
          <!-- <v-toolbar flat>
                  <v-toolbar-title>Agrani Bank-Bank List</v-toolbar-title>
                </v-toolbar> -->
          <v-card-title>
            <v-col>
              <v-row class="mt-1">
                <v-col></v-col>
                <v-col cols="12" md="4"
                  ><v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Type here to filter the table data."
                    hide-details
                    class="me-4"
                    dense
                    clearable
                  ></v-text-field
                ></v-col>
              </v-row>
            </v-col>
          </v-card-title>
        </template>
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name:"Bank List",
  data() {
    return {
      search: "",
      dessertHeaders: [
        {
          text: "Country",
          align: "start",
          sortable: false,
          value: "Country",
        },
        { text: "Location ID", value: "Location" },
        { text: "Bank name", value: "Bankname" },
        { text: "Extenal Link ID", value: "extenallinkid" },
        { text: "Branch", value: "Branch" },
        { text: "Payment mode", value: "paymentmode" },
        { text: "Is Primary Agent", value: "Primaryagent" },
        { text: "Is Active", value: "actions" },
      ],
      desserts: [
        {
          Country: "Bangladesh",
          Location: "2849",
          Bankname: "Agrani Bank",
          extenallinkid: "112",
          Branch: "Branch",
          paymentmode: "Bank Transfer",
          Primaryagent: "No",
        },
      ],
      editPage() {
        this.$router.push({ name: "Edit Bank" });
      },
      Bankbranch() {
        this.$router.push({ name: "Bank Branch" });
      },
    };
  },
  components: {
    BreadCrumb,
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
</style>
